module.exports = __webpack_public_path__ + "static/media/coverImg-UpZone.9efc2bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/UpZone/coverImg-UpZone.png
// module id = 35
// module chunks = 0